import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth-store';
import { useDomainStore } from '@/lib/domain-store';
import { Button } from '@/components/ui/button';
import { LogIn, LogOut, ShieldCheck, Building2 } from 'lucide-react';

export function AuthHeader() {
  const { user, profile, reseller, signOut } = useAuthStore();
  const { domainReseller, domainChecked } = useDomainStore();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
  };

  if (!user) {
    if (!domainChecked || domainReseller) {
      return null;
    }
    return (
      <Button
        onClick={() => navigate('/login')}
        size="sm"
        className="bg-[#212b4f] hover:bg-[#2d3a6b] text-white h-8 text-xs gap-1.5 px-3"
      >
        <LogIn className="h-3.5 w-3.5" />
        Sign in
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-2">
      {profile?.role === 'admin' && (
        <Button
          onClick={() => navigate('/admin')}
          size="sm"
          variant="outline"
          className="h-8 text-xs gap-1.5 px-3 border-[#212b4f] text-[#212b4f] hover:bg-[#212b4f] hover:text-white"
        >
          <ShieldCheck className="h-3.5 w-3.5" />
          Admin
        </Button>
      )}
      {profile?.role === 'reseller' && reseller && (
        <Button
          onClick={() => navigate('/reseller')}
          size="sm"
          variant="outline"
          className="h-8 text-xs gap-1.5 px-3 border-[#212b4f] text-[#212b4f] hover:bg-[#212b4f] hover:text-white"
        >
          <Building2 className="h-3.5 w-3.5" />
          {reseller.name}
        </Button>
      )}
      <Button
        onClick={handleSignOut}
        size="sm"
        variant="ghost"
        className="h-8 text-xs gap-1.5 px-3 text-slate-500 hover:text-slate-800"
      >
        <LogOut className="h-3.5 w-3.5" />
        Sign out
      </Button>
    </div>
  );
}
